import { Navigate, Outlet } from "react-router-dom";
import { useFeatureFlags } from "@/providers/FeatureFlagsProvider";
import { FEATURE_FLAGS, FeatureKey } from "@/lib/featureFlags";

interface FeatureFlagProtectedRouteProps {
	feature: FeatureKey;
	children?: React.ReactNode;
}

export const FeatureFlagProtectedRoute = ({ feature, children }: FeatureFlagProtectedRouteProps) => {
	const { flags, loading, error } = useFeatureFlags();

	// Hold navigation until flags resolve so deep links to gated pages
	// don't bounce to the dashboard while the defaults are still in place.
	if (loading)
		return null;

	// Fail open on load errors and unknown keys, matching useFeatureFlag.
	const enabled = error || !(feature in FEATURE_FLAGS) ? true : flags[feature];

	if (!enabled)
		return <Navigate to="/" replace />;

	return children ? <>{children}</> : <Outlet />;
};
